import { useEffect, useState } from 'react';
import { SLUG } from './storeConfig';

// Small per-device product-id lists (wishlist, recently viewed) kept in localStorage —
// no login needed, same as the bag (see bag.js).
function makeList(key, max) {
  const storageKey = `${SLUG}_${key}`;
  const event = `bs-${key}-change`;
  const read = () => {
    try { const v = JSON.parse(localStorage.getItem(storageKey)); return Array.isArray(v) ? v : []; } catch { return []; }
  };
  const write = (ids) => {
    try { localStorage.setItem(storageKey, JSON.stringify(ids.slice(0, max))); } catch { /* storage blocked */ }
    window.dispatchEvent(new Event(event));
  };
  const useList = () => {
    const [ids, setIds] = useState(read);
    useEffect(() => {
      const sync = () => setIds(read());
      window.addEventListener(event, sync);
      window.addEventListener('storage', sync);
      return () => { window.removeEventListener(event, sync); window.removeEventListener('storage', sync); };
    }, []);
    return ids;
  };
  return { read, write, use: useList };
}

const wishlist = makeList('wishlist', 200);
export const useWishlist = wishlist.use;
export function toggleWishlist(productId) {
  const ids = wishlist.read();
  const has = ids.some(id => String(id) === String(productId));
  wishlist.write(has ? ids.filter(id => String(id) !== String(productId)) : [productId, ...ids]);
  return !has;
}

const recent = makeList('recently_viewed', 20);
export const useRecentlyViewed = recent.use;
export function markViewed(productId) {
  recent.write([productId, ...recent.read().filter(id => String(id) !== String(productId))]);
}
